import React, { Component, useRef } from "react";
import "./App.css";
import { Link, Redirect, withRouter } from "react-router-dom";
import Axios from "axios";
import {
  BsPlus,
  BsDash,
  BsCircle,
  BsCheckCircle,
  BsInfo,
} from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { IoIosArrowBack } from "react-icons/io";
import { v4 as uuidv4 } from "uuid";
import Header2 from "./components/Header2";
// import Header from "./components/Header";
import ClipLoader from "react-spinners/ClipLoader";
import md5 from "md5";
import calculateBookingFee from "./components/calculateBookingFee";
import BookingFeeBreakdownModal from "./modals/BookingFeesModa";
import { BiInfoSquare, BiSolidInfoCircle } from "react-icons/bi";
import Header from "./layouts/Header";

const uuid = uuidv4().toUpperCase();
const uuid1 = uuidv4().toUpperCase();
const uuid2 = uuidv4().toUpperCase();
const uuid3 = uuidv4().toUpperCase();
const uuid4 = uuidv4().toUpperCase();
const uuid5 = uuidv4().toUpperCase();
const uuid6 = uuidv4().toUpperCase();

const customer_id = localStorage.getItem("customerid");

class Finalize extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    const query = new URLSearchParams(this.props.location.search);
    this.state = {
      payfastData: [],
      buyBtnLabel: "Secure Payment (PayFast)",
      buyBtnLabelOzow: "Secure Payment (Ozow)",
      error: "",
      products: [],
      isChecked: false,
      isBtnDisabled: true,
      add: null,
      minus: null,
      admissionValue: 1,
      total: query.get("price"),
      price: query.get("price"),
      kidsPrice: query.get("kids_price"),
      btnClasses: ["btn-disabled w-100 text-bold"],
      btnClassesOzow: ["btn-disabled w-100 text-bold"],
      fullname: null,
      response: "",
      maxMessage: "",
      ticketnumber: Math.random().toString(36).substr(2, 7).toUpperCase(),
      phone: "",
      email: "",
      key: Math.random().toString(36).substr(1, 100).toUpperCase(),
      checkedOne: true,
      uncheckedOne: false,
      checkedTwo: false,
      uncheckedTwo: true,
      activeOne: "item-select-active-checkout",
      activeTwo: "item-select-checkout",
      customer_email_address: "",
      customer_name: "",
      customer_phone: "",
      customerId: null,
      showModal: false,
      ticketType: "",
      fetchingTickets: true,
      description: "",
      venue: "",
      eventName: "",
      eventDate: "",
      startTime: "",
      endTime: "",
      poster: "",
      businessId: 0,
      eventId: 0,
      campaignStatus: "stop",
    };
  }

  // const [showModal, setShowModal] = useState(false);

  componentDidMount() {
    setTimeout(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    }, 0); // Delay ensures DOM is fully rendered

    const query = new URLSearchParams(this.props.location.search);
    const { eventid, pageid } = this.props.match.params;
    console.log(pageid);
    console.log(eventid);
    document.title = "Karamale | " + query.get("eventname");
    localStorage.setItem("group", "adults");
    let { eventname, ticketid } = 0;

    if (
      query.has("eventid") &&
      query.has("eventname") &&
      query.has("eventDate") &&
      query.has("fulldate") &&
      query.has("posterUri") &&
      query.has("accountid") &&
      query.has("accounttype") &&
      query.has("venue") &&
      query.has("description") &&
      query.has("businessid") &&
      query.has("poster") &&
      query.has("eventday") &&
      query.has("starttime") &&
      query.has("endtime") &&
      query.has("previousPage") &&
      query.has("campaignStatus") &&
      query.has("ticketid") &&
      query.has("ticketref") &&
      query.has("command") &&
      query.has("eventtype")
    ) {
      // All required query params are present
    } else {
      this.props.history.goBack(); // or your fallback route

      // this.props.history.push("/event/" + eventid + "/tickets");
    }
    const avail_tickets = query.get("avail_tickets");
    const kids_tickets = query.get("kids_tickets");

    if (avail_tickets == 0 && localStorage.getItem("group") == "adults") {
      this.setState({ admissionValue: 0, total: 0 });
    }

    if (kids_tickets == 0 && localStorage.getItem("group") == "kids") {
      this.setState({ admissionValue: 0, total: 0 });
    }

    // get event details
    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=FETCH-EVENT-DETAILS&eventid=" +
        eventid,
      {
        withCredentials: true,
      }
    ).then((response) => {
      this.setState({
        description: response.data.description,
        venue: response.data.venue,
        eventName: response.data.eventName,
        eventDate: response.data.eventDate,
        startTime: response.data.startTime,
        poster: response.data.poster,
        businessId: response.data.businessId,
        endTime: response.data.endTime,
        campaignStatus: response.data.campaignStatus,
      });
    });

    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=LOG-EVENT-CLICKS&event_id=${eventid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });

    Axios.get(
      `https://karamale.com/apps/kscanner/webservices.php?query=CUSTOMERDETAILS`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        this.setState({
          customer_email_address: response.data.email,
          customer_name: response.data.customername,
          customer_phone: response.data.phone,
          customerId: response.data.customer_id,
        });
      })
      .catch((err) => console.log(err));
  }

  handleChange = this.handleChange.bind(this);
  handleEmail = this.handleEmail.bind(this);
  handlePhone = this.handlePhone.bind(this);
  handleAdmission = this.handleAdmission.bind(this);
  handleTotal = this.handleTotal.bind(this);
  handleSubmit = this.handleSubmit.bind(this);

  handleTotal(event) {
    this.setState({ total: event.target.value });
  }

  handleAdmission(event) {
    this.setState({ admissionValue: event.target.value });
  }
  handlePhone(event) {
    this.setState({ phone: event.target.value });

    const livePhone = event.target.value;
    const formData = new FormData();
    formData.append("phone", livePhone);

    const url = "/getUserEmail";
    Axios.post(url, formData).then((res) => {
      this.setState({ email: res.data[0].email });
      this.setState({ fullname: res.data[0].fname + " " + res.data[0].lname });
      console.log(res.data[0].email);
    });
  }

  handleEmail(event) {
    this.setState({ email: event.target.value });
    const liveEmail = event.target.value;
    const formData = new FormData();
    formData.append("email", liveEmail);

    const url = "/getUserPhone";
    Axios.post(url, formData).then((res) => {
      this.setState({ phone: res.data[0].phone });
      this.setState({ fullname: res.data[0].fname + " " + res.data[0].lname });
      console.log(res.data[0].phone);
    });
  }

  handleChange(event) {
    this.setState({ fullname: event.target.value });
  }

  checkHandleClicked = () => {
    this.setState((prevState) => ({
      isChecked: !this.state.isChecked,
      isBtnDisabled: this.state.isChecked ? true : false,
      btnClasses: this.state.isChecked
        ? ["btn-disabled w-100"]
        : ["save-btn w-100"],
      btnClassesOzow: this.state.isChecked
        ? ["btn-disabled w-100"]
        : ["ozowButton w-100"],
    }));
  };

  addHandle = () => {
    // const pricetag = this.props.location.state.price;
    const admissionValue = this.state.admissionValue;
    const query = new URLSearchParams(this.props.location.search);

    const eventid = query.get("eventid");
    const businessid = query.get("businessid");
    const ticketid = query.get("ticketid");
    let pricetag = query.get("price");
    const avail_tickets = query.get("avail_tickets");
    const kids_tickets = query.get("kids_tickets");
    let ticketsAvailable = avail_tickets;

    if (localStorage.getItem("group") == "kids") {
      pricetag = query.get("kids_price");
      ticketsAvailable = kids_tickets;
    } else {
      pricetag = query.get("price");
      ticketsAvailable = avail_tickets;
    }

    if (avail_tickets == 0 && localStorage.getItem("group") == "adults") {
      this.setState({
        maxMessage:
          "Tickets for " + localStorage.getItem("group") + " are sold out",
      });
    } else if (kids_tickets == 0 && localStorage.getItem("group") == "kids") {
      this.setState({
        maxMessage:
          "Tickets for " + localStorage.getItem("group") + " are sold out",
      });
    } else {
      Axios.get(
        "https://karamale.com/apps/kscanner/webservices.php?query=CHECKAVAILABLETICKETS&eventid=" +
          eventid +
          "&ticketid=" +
          ticketid
      ).then((response) => {
        let category = "";

        if (response.data.category == "general") {
          category = "General";
        } else {
          category = response.data.category.toUpperCase();
        }
        if (admissionValue >= parseInt(ticketsAvailable)) {
          let plural,
            pastTense = "";

          if (ticketsAvailable == 1) {
            plural = "ticket";
            pastTense = "was";
          } else {
            plural = "tickets";
            pastTense = "are";
          }
          this.setState({
            maxMessage:
              "There " +
              " " +
              pastTense +
              " " +
              ticketsAvailable +
              " " +
              category +
              " " +
              plural +
              " left",
          });
        } else {
          if (admissionValue == 15) {
            this.setState({
              maxMessage: "You've reached the maximum of 15",
            });
          } else {
            if (admissionValue > 0) {
              this.setState({ maxMessage: "" });
            }

            this.setState((prevState) => ({
              admissionValue: prevState.admissionValue + 1,
              total: parseInt(prevState.total) + parseInt(pricetag),
            }));
          }
        }
      });
    }
  };

  minusHandle = () => {
    const query = new URLSearchParams(this.props.location.search);
    let pricetag = query.get("price");
    if (localStorage.getItem("group") == "kids") {
      pricetag = query.get("kids_price");
    } else {
      pricetag = query.get("price");
    }

    const admissionValue = this.state.admissionValue;
    if (admissionValue == 1 || admissionValue <= 0) {
      this.setState({ maxMessage: "You've reached the minimum" });
    } else {
      if (admissionValue < 16) {
        this.setState({ maxMessage: "" });
      }
      this.setState((prevState) => ({
        admissionValue: prevState.admissionValue - 1,
        total: prevState.total - pricetag,
      }));
    }
  };

  handleSubmit(aform_reference) {
    // event.preventDefault();
    // const data = new FormData(event.target);
    const query = new URLSearchParams(this.props.location.search);
    const data = {
      eventid: query.get("eventid"),
      businessid: query.get("businessid"),
      ticketid: query.get("ticketid"),
      ticketref: this.state.ticketnumber,
      total: this.state.total,
      price: this.state.price,
      admissionValue: this.state.admissionValue,
      phone: this.state.phone,
      email: this.state.email,
      fullname: this.state.fullname,
    };
    // Axios.post("/api/insert/ticket/buyer/details", data)
    //   .then((res) => console.log(res))
    //   .catch((err) => console.log(err));

    // var aform = aform_reference;
    // aform["amounts"].value =
    //   Math.round(aform["amounts"].value * Math.pow(10, 2)) / Math.pow(10, 2);
    // aform["custom_amount"].value = aform["custom_amount"].value.replace(
    //   /^\s+|\s+$/g,
    //   ""
    // );
    // if (
    //   !aform["custom_amount"].value ||
    //   0 === aform["custom_amount"].value.length ||
    //   /^\s*$/.test(aform["custom_amount"].value)
    // ) {
    //   alert("An amount is required");
    //   return false;
    // }
    // aform["amounts"].value =
    //   Math.round(aform["custom_amount"].value * Math.pow(10, 2)) /
    //   Math.pow(10, 2);
  }

  // click_a54ad269093bbef584e1bd2cfe93c8cf(aform_reference) {
  //   var aform = aform_reference;
  //   aform["amounts"].value =
  //     Math.round(aform["amounts"].value * Math.pow(10, 2)) / Math.pow(10, 2);
  //   aform["custom_amount"].value = aform["custom_amount"].value.replace(
  //     /^\s+|\s+$/g,
  //     ""
  //   );
  //   if (
  //     !aform["custom_amount"].value ||
  //     0 === aform["custom_amount"].value.length ||
  //     /^\s*$/.test(aform["custom_amount"].value)
  //   ) {
  //     alert("An amount is required");
  //     return false;
  //   }
  //   aform["amounts"].value =
  //     Math.round(aform["custom_amount"].value * Math.pow(10, 2)) /
  //     Math.pow(10, 2);
  // }

  adults = () => {
    const query = new URLSearchParams(this.props.location.search);
    localStorage.setItem("group", "adults");
    const avail_tickets = query.get("avail_tickets");
    if (avail_tickets == 0 && localStorage.getItem("group") == "adults") {
      this.setState({ admissionValue: 0, total: 0 });
    } else {
      this.setState({ admissionValue: 1, total: this.state.price });
    }

    this.setState({
      activeOne: "item-select-active-checkout",
      activeTwo: "item-select-checkout",
      checkedOne: true,
      uncheckedOne: false,
      checkedTwo: false,
      uncheckedTwo: true,
      maxMessage: "",
    });
  };

  kids = () => {
    const query = new URLSearchParams(this.props.location.search);
    localStorage.setItem("group", "kids");
    const kids_tickets = query.get("kids_tickets");
    if (kids_tickets == 0 && localStorage.getItem("group") == "kids") {
      this.setState({ admissionValue: 0, total: 0 });
    } else {
      this.setState({ admissionValue: 1, total: this.state.kidsPrice });
    }
    this.setState({
      activeOne: "item-select-checkout",
      activeTwo: "item-select-active-checkout",
      checkedOne: false,
      uncheckedOne: true,
      checkedTwo: true,
      uncheckedTwo: false,
      maxMessage: "",
    });
  };

  render() {
    const {
      products,
      checkedOne,
      uncheckedOne,
      checkedTwo,
      uncheckedTwo,
      activeOne,
      activeTwo,
    } = this.state;
    const query = new URLSearchParams(this.props.location.search);

    const accountid = query.get("accountid");
    const eventid = query.get("eventid");
    const eventDate = query.get("eventDate");
    // const fulldate = query.get("fulldate");
    const customerid = query.get("customerid");
    const posterUri = query.get("posterUri");
    const accounttype = query.get("accounttype");
    const customername = query.get("customername");
    const venue = query.get("venue");
    const description = query.get("description");
    const businessid = query.get("businessid");
    const poster = query.get("poster");
    const eventname = query.get("eventname");
    const eventday = query.get("eventday");
    const starttime = query.get("starttime");
    const endtime = query.get("endtime");
    const price = query.get("price");
    const kids_price = query.get("kids_price");
    const eventtype = query.get("eventtype");
    const province = query.get("province");
    const category = query.get("category");
    const previousPage = query.get("previousPage");
    const prevPage = query.get("prevPage");

    const sold = query.get("sold");
    const avail_tickets = query.get("avail_tickets");
    const kids_sold = query.get("kids_sold");
    const kids_tickets = query.get("kids_tickets");

    const campaignStatus = query.get("campaignStatus");
    const email = query.get("email");
    const phone = query.get("phone");

    let soldOutAdults,
      soldOutKids = "";
    if (parseInt(avail_tickets) === 0) {
      soldOutAdults = (
        <label className="mb-0 color-red font-size-12 font-normal w-100 text-center">
          Sold out
        </label>
      );
    } else {
      soldOutAdults = (
        <label className="mb-0 text-grey font-size-12 font-normal w-100 text-center">
          Tickets still available.
        </label>
      );
    }

    if (parseInt(kids_tickets) === 0) {
      soldOutKids = (
        <label className="mb-0 color-red font-size-12 font-normal w-100 text-center">
          Sold out
        </label>
      );
    } else {
      soldOutKids = (
        <label className="mb-0 text-grey font-size-12 font-normal w-100 text-center">
          Tickets still available.
        </label>
      );
    }

    const pay = (
      payment_source,
      category, // general, vvip, vip
      phone,
      customername, // fullname
      item_name, // item_name
      amount,
      admission, // ticket admission,
      price,
      kidsPrice,
      key,
      email,
      ticketnumber,
      ticketid,
      eventid,
      businessid,
      payment_method,
      group,
      type
    ) => {
      this.setState({
        btnClasses: "btn-disabled w-100",
        btnClassesOzow: "btn-disabled w-100",
        isBtnDisabled: true,
      });

      if (payment_source === "payfast") {
        this.setState({
          buyBtnLabel: <ClipLoader size={20} color="grey" />,
        });
      } else {
        this.setState({
          buyBtnLabelOzow: <ClipLoader size={20} color="grey" />,
        });
      }

      // write code...
      const name_first = this.state.customer_name.split(/\s+/)[0];
      const name_last = this.state.customer_name.split(/\s+/)[1];

      let mobileSet;
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

      if (isMobile) {
        mobileSet = "yes";
      } else {
        mobileSet = "no";
      }
      // this.setState({
      //   isBtnDisabled: true,
      //   buyBtnLabel: <ClipLoader size={20} color="#fff" />,
      // });

      const userAgent = navigator.userAgent;
      const language = navigator.language;
      const screenResolution = window.screen.width + "x" + window.screen.height;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const platform = navigator.platform;
      const cpuCores = navigator.hardwareConcurrency || 0;
      const deviceMemory = navigator.deviceMemory || 0;
      const touchPoints = navigator.maxTouchPoints || 0;

      const totalAmount = parseFloat(formattedTotalFee.replace(/[R,]/g, ""));
      const formData = new FormData();
      formData.append("item_name", item_name);
      formData.append("amount", totalAmount.toFixed(2));
      formData.append("email", email);
      formData.append("cell_number", phone);
      formData.append("name_first", name_first);
      formData.append("name_last", name_last);
      formData.append("admission", admission);
      formData.append("adults_price", price);
      formData.append("kids_price", kidsPrice);
      formData.append("category", category);
      formData.append("ticketid", ticketid);
      formData.append("ticketnumber", ticketnumber);
      formData.append("eventid", eventid);
      formData.append("payment_method", payment_method);
      formData.append("businessid", businessid);
      formData.append("type", type);
      formData.append("group", group);
      formData.append("is_mobile", mobileSet);
      formData.append("customer_id", this.state.customerId);
      formData.append("user_agent", userAgent);
      formData.append("language", language);
      formData.append("screen_resolution", screenResolution);
      formData.append("timezone", timezone);
      formData.append("platform", platform);
      formData.append("cpu_cores", cpuCores);
      formData.append("device_memory", deviceMemory);
      formData.append("touch_points", touchPoints);

      let postUrl =
        "https://karamale.com/apps/kscanner/payfast_credentials.php";

      if (payment_source === "ozow") {
        postUrl = "https://karamale.com/apps/kscanner/ozowCredentials.php";
      }

      fetch(`${postUrl}`, {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "failed") {
            alert(data.message);
            return;
          }
          if (data.status === "review") {
            this.props.history.push({
              pathname: "/verification-process",
              state: {
                m_payment_id: data.m_payment_id,
                reponseMessage: data.message,
                customer_id: data.customer_id,
              },
            });
            return;
          }
          // console.log("uuid: " + data.signature);

          if (isMobile || payment_source === "ozow") {
            this.setState({
              payfastData: data,
            });

            const form = document.createElement("form");
            form.method = "POST";
            form.action =
              payment_source === "ozow"
                ? data.ozowUrl
                : "https://www.payfast.co.za/eng/process";

            for (const [key, value] of Object.entries(data)) {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = key;
              input.value = value;
              // console.log(`${key} = ${value}`);
              form.appendChild(input);
            }

            document.body.appendChild(form);
            form.submit();

            // const form = document.getElementById("payfast-form");
            // const dataF = new FormData(form);
            // for (const [key, value] of dataF.entries()) {
            //   console.log(`${key} = ${value}`);
            // }
            // this.formRef.current.submit();
          } else {
            if (data.uuid) {
              console.log(data.uuid);
              console.log(data.success);
              window.payfast_do_onsite_payment({
                uuid: data.uuid,
                return_url: "https://karamale.com/success",
                cancel_url: `https://karamale.com/cancelled?customer_id=${customer_id}&ticket_number=${ticketnumber}&ticket_id=${ticketid}&event_id=${eventid}&business_id=${businessid}&name_first=${
                  this.state.customer_name.split(" ")[0]
                }&name_last=${this.state.customer_name.split(" ")[1]}&email=${
                  this.state.customer_email_address
                }&item_name=${item_name}&admission=${admission}`,
              });
              this.setState({
                btnClasses: "save-btn w-100",
                btnClassesOzow: "ozowButton w-100",
                isBtnDisabled: false,
                buyBtnLabel: "Add Payment",
              });
            } else {
              alert("Failed to initiate payment.");
            }
          }

          this.setState({
            isChecked: false,
            btnClasses: "btn-disabled w-100",
            btnClassesOzow: "btn-disabled w-100",
            isBtnDisabled: true,
            buyBtnLabel: "Add payment",
          });
        });
      // }
    };

    let gatewayFlatFee,
      karamaleFee,
      estimatedGatewayFee,
      finalEstimatedGatewayFee,
      gatewayRate,
      admission,
      karamaleRate,
      bookingFee,
      totalFee,
      vat,
      subtotalFee = 0;
    const ticketPrice = this.state.checkedOne
      ? this.state.price
      : this.state.kidsPrice;

    admission = this.state.admissionValue;
    const bookingServiceFees = calculateBookingFee(ticketPrice, admission);
    bookingFee = bookingServiceFees["totalBookingFees"];
    karamaleRate = bookingServiceFees["karamaleRate"];
    karamaleFee = bookingServiceFees["bookingFeeAdmission"];
    gatewayFlatFee = bookingServiceFees["gatewayFlatFee"];
    gatewayRate = bookingServiceFees["gatewayRate"];
    estimatedGatewayFee = bookingServiceFees["estimatedGatewayFee"];
    finalEstimatedGatewayFee = bookingServiceFees["finalEstimatedGatewayFee"];
    vat = bookingServiceFees["vat"];

    subtotalFee = Number(this.state.total);
    totalFee = Number(bookingFee) + subtotalFee;

    const formattedSubtotalFee =
      "R" + subtotalFee.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const formattedBookingFee =
      "R" + bookingFee.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const formattedTotalFee =
      "R" + totalFee.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return (
      <div className="view pt-4">
        {localStorage.getItem("customername") === null ? (
          <Header />
        ) : (
          <Header />
          // <Header2 />
        )}
        {/* {loadBarProgress && <TopBarProgress />} */}
        <div className="container p-0">
          <div className="row mt-4 mb-0 w-100">
            <div className="row justify-content-center align-self-center desktop-width">
              <div className="col-lg-7 col-md-12 col-sm-12 col-12 mb-5">
                <div className="content-detail">
                  <div className="">
                    <img
                      src={poster}
                      alt={poster}
                      width="100%"
                      className="img-poster"
                    />
                  </div>
                  <div className="col-lg-12 p-0 mt-4 pb-2">
                    <div className="pb-4">
                      <h3>{this.state.eventName}</h3>
                      <p className="mb-0 whiteSpace">
                        <span className="text-13 text-black">Date:</span>
                        <br />
                        {this.state.eventDate}
                      </p>
                      <br />

                      <p className="mb-0 whiteSpace">
                        <span className="text-13 text-black">Time:</span>
                        <br />
                        {this.state.startTime} - {this.state.endTime}
                      </p>
                      <br />
                      <span className="text-13">Description</span>

                      <br />
                      <div
                        className="mb-0 whiteSpace"
                        dangerouslySetInnerHTML={{
                          __html: this.state.description,
                        }}
                      />
                      <br />
                      <br />
                      <span className="bolddiv">Venue</span>
                      <br />
                      {this.state.venue}
                      <br />
                      <br />

                      <div
                        class="mapouter"
                        style={{
                          position: "relative",
                          textAlign: "right",
                          height: "500",
                          width: "600",
                        }}
                      >
                        <div
                          class="gmap_canvas"
                          style={{
                            overflow: "hidden",
                            background: "none",
                            height: "500",
                            width: "100%",
                          }}
                        >
                          <iframe
                            width="100%"
                            height="500"
                            id="gmap_canvas"
                            src={
                              "https://maps.google.com/maps?t=&z=13&ie=UTF8&iwloc=&output=embed&q=" +
                              this.state.venue
                            }
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                localStorage.getItem("customername") === null
                  ? "d-none"
                  : "col-lg-3 col-md-12 col-sm-12 col-12 p-0"
              }
            >
              <div className="tickets pl-0 pr-0">
                <div className="">
                  <label className="w-100 text-left">
                    <label
                      className="text-black text-bold"
                      onClick={() => this.props.history.goBack()}
                    >
                      <ReactTooltip />
                      &nbsp;&nbsp;
                      <IoIosArrowBack
                        size={30}
                        className="text-black cursor-pointer"
                      />
                      &nbsp;&nbsp;Back
                    </label>
                  </label>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {category} <br />
                  <div className="row w-100 mt-2 align-items-center ticket-title">
                    {price <= 0 ? (
                      ""
                    ) : (
                      <div className="col-6 pl-0 pr-1">
                        <label
                          className={activeOne + " p-2 w-100 border-1"}
                          onClick={this.adults}
                        >
                          <label className="small-details mb-0 font-normal text-center w-100 cursor-pointer">
                            Adults:&nbsp;R{Number(price).toFixed(2)}
                          </label>
                        </label>
                        {soldOutAdults}
                      </div>
                    )}

                    {kids_price <= 0 ? (
                      ""
                    ) : (
                      <div className="col-6 pl-1 pr-0">
                        <label
                          className={activeTwo + " p-2 w-100 border-1"}
                          onClick={this.kids}
                        >
                          <label className="small-details mb-0 font-normal text-center w-100 cursor-pointer">
                            Kids:&nbsp;R{Number(kids_price).toFixed(2)}
                          </label>
                        </label>
                        {soldOutKids}
                      </div>
                    )}
                  </div>
                  <div className="h-divider w-100" />
                </div>
                <div className="pl-0 pr-0 pt-0">
                  <div className="upperCasedText">
                    <span className="capitalizedText textLight">
                      <div className="row">
                        <div className="col-lg-12 form-components ">
                          <label className="normal-casing">
                            <Link to="/profile" className="click-here">
                              Change details{" "}
                            </Link>
                          </label>
                          <br />
                          <span className="buy-text">Name</span>
                          <br />
                          <label class="small-details">
                            {this.state.customer_name}
                          </label>
                          <br />
                          <span className="buy-text">Email</span>
                          <br />
                          <label class="small-details lower-casing">
                            {this.state.customer_email_address}
                          </label>
                          <br />
                          <span className="buy-text">Phone</span>
                          <br />
                          <label class="small-details">
                            {this.state.customer_phone}
                          </label>
                          <br />
                          <br />
                          <label className="textLight w-100">
                            <span className="">Subtotal</span>
                            <span className="float-right textLight text-15">
                              <span className="float-right textLight text-15">
                                {formattedSubtotalFee}
                              </span>
                              <input
                                type="hidden"
                                readOnly
                                value={this.state.total}
                                onChange={this.handleTotal}
                                className="totalAmount"
                                style={{ padding: 0 }}
                              />
                            </span>
                          </label>
                          <div className="textLight w-100">
                            <label>
                              <span
                                className="ursor-pointer"
                                onClick={() =>
                                  this.setState({ showModal: true })
                                }
                              >
                                Booking fee
                              </span>
                            </label>
                            <span className="float-right textLight text-grey">
                              {formattedBookingFee}
                            </span>
                            {this.state.showModal && (
                              <BookingFeeBreakdownModal
                                ticketPrice={ticketPrice}
                                bookingFee={bookingFee}
                                karamaleFee={karamaleFee}
                                karamaleRate={karamaleRate}
                                gatewayFlatFee={gatewayFlatFee}
                                gatewayRate={gatewayRate}
                                estimatedGatewayFee={estimatedGatewayFee}
                                finalEstimatedGatewayFee={
                                  finalEstimatedGatewayFee
                                }
                                onClose={() =>
                                  this.setState({ showModal: false })
                                }
                              />
                            )}
                          </div>
                          <label className="textLight w-100">
                            <span className="">Total</span>
                            <span className="float-right textLight">
                              {formattedTotalFee}
                            </span>
                          </label>
                          <label className="max-message">
                            {this.state.maxMessage}
                          </label>
                          <br />
                          <div className="row mb-3">
                            <div className="col-4 pr-2 pl-0">
                              <button
                                className="minus"
                                type="button"
                                onClick={this.minusHandle}
                              >
                                <BsDash />
                              </button>
                            </div>
                            <div className="col-4 pr-2 pl-2">
                              <input
                                type="text"
                                name="admission"
                                className="admissionInput"
                                placeholder="0"
                                readOnly
                                value={this.state.admissionValue}
                                onChange={this.handleAdmission}
                              />
                            </div>
                            <div className="col-4 pr-0 pl-2">
                              <button
                                className="add"
                                id="add"
                                type="button"
                                onClick={this.addHandle}
                              >
                                <BsPlus />
                              </button>
                              <input
                                type="hidden"
                                value={
                                  localStorage.getItem("group") == "kids"
                                    ? this.state.kidsPrice
                                    : this.state.price
                                }
                              />
                              <input
                                type="hidden"
                                value={query.get("businessid")}
                              />
                              <input
                                type="hidden"
                                value={query.get("ticketid")}
                              />
                              <input
                                type="hidden"
                                value={query.get("eventid")}
                              />
                              <input
                                type="hidden"
                                value={this.state.ticketnumber}
                              />

                              <input type="hidden" name="cmd" value="_paynow" />

                              <input
                                type="hidden"
                                name="receiver"
                                value="15455113"
                              />

                              <input
                                type="hidden"
                                name="merchant_key"
                                value="jwmwjkoveei5b"
                              />

                              <input
                                type="hidden"
                                name="item_name"
                                value={eventname}
                              />

                              <input
                                type="hidden"
                                name="amount"
                                id="amount"
                                value={this.state.total}
                              />

                              <input
                                type="hidden"
                                name="item_description"
                                value=""
                              />

                              <input
                                type="hidden"
                                name="return_url"
                                id="return_url_"
                                value={"https://karamale.com/success"}
                              />

                              <input
                                type="hidden"
                                name="cancel_url"
                                id="cancel_url_"
                                value={
                                  "https://karamale.com/cancelled?buid=" +
                                  uuid6 +
                                  "&queryid=" +
                                  uuid5 +
                                  "&cancellationid=" +
                                  uuid4 +
                                  "&uid=" +
                                  uuid3 +
                                  "&qKey=" +
                                  uuid1 +
                                  "&key=" +
                                  uuid2 +
                                  "&uuid=" +
                                  uuid +
                                  "&email=" +
                                  this.state.email +
                                  "&phaseValue=1" +
                                  "&businessId=" +
                                  query.get("businessid") +
                                  "&ticketId=" +
                                  query.get("ticketid") +
                                  "&ticketnumber=" +
                                  this.state.ticketnumber +
                                  "&eventId=" +
                                  query.get("eventid")
                                }
                              />

                              <input
                                type="hidden"
                                name="name_first"
                                value={customername}
                              />
                              <input
                                type="hidden"
                                name="email_address"
                                value={email}
                              />
                              <input
                                type="hidden"
                                name="cell_number"
                                value={phone}
                              />

                              <input
                                type="hidden"
                                name="notify_url"
                                id="notify_url_"
                                value={
                                  "https://karamale.com/apps/kscanner/webservices.php?query=NOTIFY?category=" +
                                  category +
                                  "&phone=" +
                                  phone +
                                  "&total=" +
                                  this.state.total +
                                  "&admission=" +
                                  this.state.admissionValue +
                                  "&price=" +
                                  this.state.price +
                                  "&kids_price=" +
                                  this.state.kidsPrice +
                                  "&key=" +
                                  this.state.key +
                                  "&email=" +
                                  email +
                                  "&ticketnumber=" +
                                  this.state.ticketnumber +
                                  "&ticketid=" +
                                  query.get("ticketid") +
                                  "&eventid=" +
                                  query.get("eventid") +
                                  "&businessid=" +
                                  query.get("businessid") +
                                  "&method=card&group=" +
                                  localStorage.getItem("group")
                                }
                              />

                              <input
                                type="hidden"
                                name="custom_amount"
                                id="custom_amounts"
                                value={0}
                                class="pricing"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div
                              className="col-12 terms text-left align-self-center mb-3 p-0"
                              style={{
                                display: "flex",
                                textTransform: "none",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={this.state.isChecked}
                                className="w-auto h-auto"
                                name="agreement"
                                onClick={this.checkHandleClicked}
                                id="agreement"
                                style={{ cursor: "pointer" }}
                              />
                              &nbsp;&nbsp;
                              <label
                                for="agreement"
                                className="mb-0 w-100 text-15 text-black cursor-pointer text-underline-none"
                              >
                                Agree to{" "}
                                <Link
                                  to={"/terms-conditions"}
                                  target="_blank"
                                  className="color-blue"
                                >
                                  Terms
                                </Link>{" "}
                                and{" "}
                                <Link
                                  to={"/ticketing-policy"}
                                  target="_blank"
                                  className="color-blue"
                                >
                                  Policy
                                </Link>
                                .
                              </label>
                            </div>
                          </div>
                          {/* <form
                            ref={this.formRef}
                            id="payfast-form"
                            method="POST"
                            action="https://www.payfast.co.za/eng/process"
                            style={{ display: "none" }}
                          >
                            {Object.entries(this.state.payfastData).map(
                              ([key, value]) => (
                                <input
                                  type="hidden"
                                  name={key}
                                  value={value}
                                  key={key}
                                />
                              )
                            )}
                          </form> */}
                          <button
                            disabled={this.state.isBtnDisabled}
                            className={`${this.state.btnClassesOzow} mb-3`}
                            onClick={() =>
                              pay(
                                "ozow",
                                category,
                                this.state.customer_phone,
                                this.state.customer_name, // fullname
                                eventname, // item_name
                                this.state.total, // amount
                                this.state.admissionValue,
                                this.state.price,
                                this.state.kidsPrice,
                                this.state.key,
                                this.state.customer_email_address,
                                this.state.ticketnumber,
                                query.get("ticketid"),
                                query.get("eventid"),
                                query.get("businessid"),
                                "eft",
                                localStorage.getItem("group"),
                                "purchase_ticket"
                              )
                            }
                            style={{ fontWeight: "bold" }}
                          >
                            {this.state.buyBtnLabelOzow}
                          </button>

                          <button
                            disabled={this.state.isBtnDisabled}
                            className={`${this.state.btnClasses} mb-3`}
                            onClick={() =>
                              pay(
                                "payfast",
                                category,
                                this.state.customer_phone,
                                this.state.customer_name, // fullname
                                eventname, // item_name
                                this.state.total, // amount
                                this.state.admissionValue,
                                this.state.price,
                                this.state.kidsPrice,
                                this.state.key,
                                this.state.customer_email_address,
                                this.state.ticketnumber,
                                query.get("ticketid"),
                                query.get("eventid"),
                                query.get("businessid"),
                                "eft",
                                localStorage.getItem("group"),
                                "purchase_ticket"
                              )
                            }
                            style={{ fontWeight: "bold" }}
                          >
                            {this.state.buyBtnLabel}
                          </button>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="event-name justify-content-center d-none"
          style={{ display: "flex" }}
        >
          <div
            className="backbtn event-title justify-content-center"
            style={{ display: "flex" }}
          >
            <div className="pt-1 pr-2">
              <Link
                to={{
                  pathname: "/" + prevPage,
                  search:
                    "q=" +
                    uuid6 +
                    "&queryid=" +
                    uuid5 +
                    "&pageid=" +
                    uuid4 +
                    "&uid=" +
                    uuid3 +
                    "&qKey=" +
                    uuid1 +
                    "&key=" +
                    uuid2 +
                    "&uuid=" +
                    uuid +
                    "&eventid=" +
                    query.get("eventid") +
                    "&eventDate=" +
                    query.get("eventDate") +
                    "&fulldate=" +
                    query.get("fulldate") +
                    "&customerid=" +
                    query.get("customerid") +
                    "&posterUri=" +
                    query.get("posterUri") +
                    "&accountid=" +
                    query.get("accountid") +
                    "&accounttype=" +
                    query.get("accounttype") +
                    "&customername=" +
                    query.get("customername") +
                    "&email=" +
                    query.get("email") +
                    "&phone=" +
                    query.get("phone") +
                    "&venue=" +
                    query.get("venue") +
                    "&description=" +
                    query.get("description") +
                    "&businessid=" +
                    query.get("businessid") +
                    "&poster=" +
                    query.get("poster") +
                    "&eventname=" +
                    query.get("eventname") +
                    "&eventday=" +
                    query.get("eventday") +
                    "&starttime=" +
                    query.get("starttime") +
                    "&endtime=" +
                    query.get("endtime") +
                    "&previousPage=" +
                    previousPage +
                    "&campaignStatus=" +
                    campaignStatus +
                    "&category=" +
                    eventtype +
                    "&province=" +
                    province,
                  state: {
                    fromHome: true,
                    eventid: query.get("eventid"),
                    eventDate: query.get("eventDate"),
                    // fulldate: query.get("fulldate"),
                    customerid: query.get("customerid"),
                    posterUri: query.get("posterUri"),
                    accountid: query.get("accountid"),
                    accounttype: query.get("accounttype"),
                    customername: query.get("customername"),
                    email: query.get("email"),
                    phone: query.get("phone"),
                    venue: query.get("venue"),
                    description: query.get("description"),
                    businessid: query.get("businessid"),
                    poster: query.get("poster"),
                    eventname: query.get("eventname"),
                    eventday: query.get("eventday"),
                    starttime: query.get("starttime"),
                    endtime: query.get("endtime"),
                    previousPage: previousPage,
                    campaignStatus: campaignStatus,
                    category: eventtype,
                    province: province,
                  },
                }}
                className="backArrow"
                data-tip="Back"
                data-effect="solid"
                data-arrow-color="transparent"
                data-type="dark"
                data-place="top"
              >
                <ReactTooltip />
                <IoIosArrowBack size={40} className="Back-arrow-blue" />
              </Link>
            </div>
            <div className="" style={{ textAlign: "center" }}>
              {eventname}
              <br />
              <span style={{ fontSize: 13, color: "grey", fontWeight: 400 }}>
                {eventday} @ {starttime}
              </span>
              {localStorage.getItem("customername") === null ? (
                <span>
                  <br />
                  <label>
                    <Link to="/login">Login</Link>{" "}
                    <span style={{ textTransform: "lowercase" }}>or</span>{" "}
                    <Link to="/register">Register</Link>{" "}
                    <span style={{ textTransform: "lowercase" }}>
                      to purchase tickets
                    </span>
                  </label>
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="blanket"></div>
      </div>
    );
  }
}

export default Finalize;
